import Axios from "@/plugins/Axios";

export class RelatorioAtendimentosService {
  async analitico(meses) {
    try {
      const response = await Axios().get("relatorios-atendimentos/analitico", {
        params: { meses },
        responseType: "arraybuffer",
      });
      const blob = new Blob([response.data], { type: "application/pdf" });
      window.open(window.URL.createObjectURL(blob));
    } catch (err) {
      throw this.tratarErroArraybuffer(err);
    }
  }

  tratarErroArraybuffer(err) {
    const buffer = err instanceof ArrayBuffer ? err : err?.response?.data;
    if (buffer instanceof ArrayBuffer) {
      try {
        const decoded = JSON.parse(new TextDecoder("utf-8").decode(buffer));
        return new Error(
          decoded.message || decoded.error?.message || "Não foi possível gerar o relatório."
        );
      } catch (e) {
        return new Error("Não foi possível gerar o relatório.");
      }
    }
    return err;
  }
}

export default new RelatorioAtendimentosService();
